import { collections } from "@/mocks/home";
import SectionHead from "./SectionHead";

export default function Collections() {
  return (
    <section id="topic" className="scroll-mt-24 border-y border-background-200 bg-background-100/70">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <SectionHead
          kicker="COLLECTION"
          title="题材合集"
          sub="把同一主题下的新瓜按合集收纳，逛起来像翻杂志，一口气看完一类动态。"
        />

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
          {collections.map((c) => (
            <article
              key={c.id}
              className="overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-background-300"
            >
              <div className="relative h-36 w-full overflow-hidden md:h-44">
                <img
                  src={c.image}
                  alt={`${c.name}题材合集封面图`}
                  className="h-full w-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 to-transparent" />
                <div className="absolute bottom-3 left-4 right-4 flex items-end justify-between">
                  <div>
                    <span className={`mb-1.5 inline-block rounded px-2 py-0.5 text-[11px] font-bold text-background-50 ${c.accent}`}>
                      {c.count}
                    </span>
                    <h3 className="font-heading text-lg font-black text-background-50 md:text-xl">{c.name}</h3>
                    <p className="text-xs text-background-50/85">{c.subtitle}</p>
                  </div>
                  <a
                    href="#stream"
                    className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-50/20 text-background-50 transition-colors hover:bg-primary-600"
                    aria-label={`浏览${c.name}合集`}
                  >
                    <i className="ri-arrow-right-line text-sm" />
                  </a>
                </div>
              </div>

              <div className="divide-y divide-background-100">
                {c.items.map((it) => (
                  <a
                    key={it.title}
                    href="#stream"
                    className="group flex items-center gap-3 px-4 py-3 transition-colors hover:bg-background-100"
                  >
                    <span className="flex-1 truncate text-sm text-foreground-800 group-hover:text-primary-700">
                      {it.title}
                    </span>
                    <span className="hidden items-center gap-1 text-xs text-foreground-400 sm:flex">
                      <i className="ri-fire-line" />
                      {it.heat}
                    </span>
                    <span className="shrink-0 text-xs text-foreground-400">{it.time}</span>
                  </a>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}